// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2m3E2","topBottomGutter":"Layout_topBottomGutter__3Jaqq"};